import React, { useState } from "react";
import { SocioServiceFirestore } from "../../services/SocioServiceFirestore";

const columnas = [
  "H",
  "user_login",
  "user_pass",
  "user_nicename",
  "user_email",
  "user_url",
  "user_registered",
  "user_activation_key",
  "user_status",
  "display_name",
  "GUID",
  "NOTAS",
  "NOMBRE CORTO",
  "NOMBRE SERVERS VRS",
  "SOCIO",
  "Categoria",
  "PAIS",
  "EQUIPO"
];

const SociosImport: React.FC = () => {
  const [rawData, setRawData] = useState("");
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState<string | null>(null);

  const parseRows = (text: string) => {
    // Soporta tabuladores (Excel) o CSV
    const rows = text.trim().split(/\r?\n/);
    // Si la primera fila es cabecera, la saltamos
    let startIdx = 0;
    if (rows[0].toLowerCase().includes("user_login")) startIdx = 1;
    return rows.slice(startIdx).map(row => row.split(/\t|,/));
  };

  const handleImport = async () => {
    setImporting(true);
    setResult(null);
    try {
      const socios = parseRows(rawData).map(cols => {
        const socio: any = {};
        columnas.forEach((col, i) => {
          socio[col.replace(/\s+/g, '_')] = cols[i] || "";
        });
        return socio;
      });
      // Subir a Firestore
      for (const socio of socios) {
        await SocioServiceFirestore.create(socio);
      }
      setResult(`Importados ${socios.length} socios correctamente.`);
    } catch (err: any) {
      setResult("Error importando: " + err.message);
    }
    setImporting(false);
  };

  return (
    <div style={{ maxWidth: 600, margin: "2rem auto", padding: 20, border: "1px solid #ccc", borderRadius: 8 }}>
      <h2>Importar Socios desde Excel</h2>
      <ol>
        <li>Copia las filas desde tu Excel (incluyendo la cabecera).</li>
        <li>Pega aquí el contenido:</li>
      </ol>
      <textarea
        rows={10}
        style={{ width: "100%", marginBottom: 12 }}
        value={rawData}
        onChange={e => setRawData(e.target.value)}
        placeholder={columnas.join("\t") + "\n..."}
      />
      <button onClick={handleImport} disabled={importing || !rawData.trim()} style={{ width: "100%", padding: 10 }}>
        {importing ? "Importando..." : "Importar a Firestore"}
      </button>
      {result && <p style={{ marginTop: 16 }}>{result}</p>}
    </div>
  );
};

export default SociosImport;
